/**
 * Montant en euros au format français : « 3 397,94 € ».
 *
 * Les écrans d'appel de fonds affichaient `amount.toFixed(2)`, soit « 3397.94 € » — un format
 * anglo-saxon, sans séparateur de milliers, illisible pour le public senior de l'app.
 */
export const formatEuros = (amount: number): string =>
  amount.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
